// Comprehensive country code to country name mapping
export const getCountryFromCode = (countryCode) => {
  const countryMap = {
    '+1': 'United States',
    '+44': 'United Kingdom', 
    '+33': 'France',
    '+49': 'Germany',
    '+39': 'Italy',
    '+34': 'Spain',
    '+31': 'Netherlands',
    '+32': 'Belgium',
    '+41': 'Switzerland',
    '+43': 'Austria',
    '+45': 'Denmark',
    '+46': 'Sweden',
    '+47': 'Norway',
    '+358': 'Finland',
    '+353': 'Ireland',
    '+351': 'Portugal',
    '+30': 'Greece',
    '+48': 'Poland',
    '+420': 'Czech Republic',
    '+421': 'Slovakia',
    '+36': 'Hungary',
    '+40': 'Romania',
    '+359': 'Bulgaria',
    '+385': 'Croatia',
    '+386': 'Slovenia',
    '+372': 'Estonia',
    '+371': 'Latvia',
    '+370': 'Lithuania',
    '+7': 'Russia',
    '+380': 'Ukraine',
    '+375': 'Belarus',
    '+373': 'Moldova',
    '+381': 'Serbia',
    '+382': 'Montenegro',
    '+383': 'Kosovo',
    '+387': 'Bosnia and Herzegovina',
    '+389': 'North Macedonia',
    '+355': 'Albania',
    '+90': 'Turkey',
    '+357': 'Cyprus',
    '+356': 'Malta',
    '+354': 'Iceland',
    '+298': 'Faroe Islands',
    '+299': 'Greenland',
    '+376': 'Andorra',
    '+377': 'Monaco',
    '+378': 'San Marino',
    '+423': 'Liechtenstein',
    '+86': 'China',
    '+91': 'India',
    '+81': 'Japan',
    '+82': 'South Korea',
    '+62': 'Indonesia',
    '+60': 'Malaysia',
    '+65': 'Singapore',
    '+66': 'Thailand',
    '+84': 'Vietnam',
    '+63': 'Philippines',
    '+61': 'Australia',
    '+64': 'New Zealand',
    '+852': 'Hong Kong',
    '+853': 'Macau',
    '+886': 'Taiwan',
    '+20': 'Egypt',
    '+27': 'South Africa',
    '+234': 'Nigeria',
    '+254': 'Kenya',
    '+233': 'Ghana',
    '+212': 'Morocco',
    '+213': 'Algeria',
    '+216': 'Tunisia',
    '+218': 'Libya',
    '+249': 'Sudan',
    '+251': 'Ethiopia',
    '+256': 'Uganda',
    '+255': 'Tanzania',
    '+250': 'Rwanda',
    '+257': 'Burundi',
    '+243': 'Congo (DRC)',
    '+242': 'Congo',
    '+236': 'Central African Republic',
    '+235': 'Chad',
    '+237': 'Cameroon',
    '+240': 'Equatorial Guinea',
    '+241': 'Gabon',
    '+239': 'São Tomé and Príncipe',
    '+238': 'Cape Verde',
    '+221': 'Senegal',
    '+220': 'Gambia',
    '+224': 'Guinea',
    '+245': 'Guinea-Bissau',
    '+232': 'Sierra Leone',
    '+231': 'Liberia',
    '+225': 'Côte d\'Ivoire',
    '+226': 'Burkina Faso',
    '+223': 'Mali',
    '+227': 'Niger',
    '+229': 'Benin',
    '+228': 'Togo',
    '+230': 'Mauritius',
    '+248': 'Seychelles',
    '+261': 'Madagascar',
    '+269': 'Comoros',
    '+262': 'Réunion',
    '+290': 'Saint Helena',
    '+52': 'Mexico',
    '+54': 'Argentina',
    '+55': 'Brazil',
    '+56': 'Chile',
    '+57': 'Colombia',
    '+51': 'Peru',
    '+58': 'Venezuela',
    '+593': 'Ecuador',
    '+591': 'Bolivia',
    '+595': 'Paraguay',
    '+598': 'Uruguay',
    '+592': 'Guyana',
    '+597': 'Suriname',
    '+594': 'French Guiana',
    '+508': 'Saint Pierre and Miquelon',
    '+590': 'Guadeloupe',
    '+596': 'Martinique',
    '+599': 'Curaçao',
    '+297': 'Aruba',
    '+502': 'Guatemala',
    '+503': 'El Salvador',
    '+504': 'Honduras',
    '+505': 'Nicaragua',
    '+506': 'Costa Rica',
    '+507': 'Panama',
    '+501': 'Belize',
    '+509': 'Haiti',
    '+972': 'Israel',
    '+970': 'Palestine',
    '+971': 'United Arab Emirates',
    '+974': 'Qatar',
    '+973': 'Bahrain',
    '+965': 'Kuwait',
    '+968': 'Oman',
    '+967': 'Yemen',
    '+966': 'Saudi Arabia',
    '+964': 'Iraq',
    '+962': 'Jordan',
    '+961': 'Lebanon',
    '+963': 'Syria',
    '+98': 'Iran',
    '+93': 'Afghanistan',
    '+92': 'Pakistan',
    '+94': 'Sri Lanka',
    '+95': 'Myanmar',
    '+880': 'Bangladesh',
    '+977': 'Nepal',
    '+975': 'Bhutan',
    '+960': 'Maldives'
  };
  
  return countryMap[countryCode] || 'Unknown';
};

// Get country name from ISO code (for ProfileVerificationModal compatibility)
export const getCountryNameFromISO = (isoCode) => {
  const isoToCountryMap = {
    'US': 'United States', 'GB': 'United Kingdom', 'FR': 'France', 'DE': 'Germany',
    'IT': 'Italy', 'ES': 'Spain', 'NL': 'Netherlands', 'BE': 'Belgium',
    'CH': 'Switzerland', 'AT': 'Austria', 'DK': 'Denmark', 'SE': 'Sweden',
    'NO': 'Norway', 'FI': 'Finland', 'IE': 'Ireland', 'PT': 'Portugal',
    'GR': 'Greece', 'PL': 'Poland', 'CZ': 'Czech Republic', 'SK': 'Slovakia',
    'HU': 'Hungary', 'RO': 'Romania', 'BG': 'Bulgaria', 'HR': 'Croatia',
    'SI': 'Slovenia', 'EE': 'Estonia', 'LV': 'Latvia', 'LT': 'Lithuania',
    'RU': 'Russia', 'UA': 'Ukraine', 'BY': 'Belarus', 'MD': 'Moldova',
    'RS': 'Serbia', 'ME': 'Montenegro', 'XK': 'Kosovo', 'BA': 'Bosnia and Herzegovina',
    'MK': 'North Macedonia', 'AL': 'Albania', 'TR': 'Turkey', 'CY': 'Cyprus',
    'MT': 'Malta', 'IS': 'Iceland', 'FO': 'Faroe Islands', 'GL': 'Greenland',
    'AD': 'Andorra', 'MC': 'Monaco', 'SM': 'San Marino', 'VA': 'Vatican City',
    'LI': 'Liechtenstein', 'CN': 'China', 'IN': 'India', 'JP': 'Japan',
    'KR': 'South Korea', 'ID': 'Indonesia', 'MY': 'Malaysia', 'SG': 'Singapore',
    'TH': 'Thailand', 'VN': 'Vietnam', 'PH': 'Philippines', 'AU': 'Australia',
    'NZ': 'New Zealand', 'HK': 'Hong Kong', 'MO': 'Macau', 'TW': 'Taiwan',
    'EG': 'Egypt', 'ZA': 'South Africa', 'NG': 'Nigeria', 'KE': 'Kenya',
    'GH': 'Ghana', 'MA': 'Morocco', 'DZ': 'Algeria', 'TN': 'Tunisia',
    'LY': 'Libya', 'SD': 'Sudan', 'ET': 'Ethiopia', 'UG': 'Uganda',
    'TZ': 'Tanzania', 'RW': 'Rwanda', 'BI': 'Burundi', 'CD': 'Congo (DRC)',
    'CG': 'Congo', 'CF': 'Central African Republic', 'TD': 'Chad',
    'CM': 'Cameroon', 'GQ': 'Equatorial Guinea', 'GA': 'Gabon',
    'ST': 'São Tomé and Príncipe', 'CV': 'Cape Verde', 'SN': 'Senegal',
    'GM': 'Gambia', 'GN': 'Guinea', 'GW': 'Guinea-Bissau', 'SL': 'Sierra Leone',
    'LR': 'Liberia', 'CI': 'Côte d\'Ivoire', 'BF': 'Burkina Faso',
    'ML': 'Mali', 'NE': 'Niger', 'BJ': 'Benin', 'TG': 'Togo',
    'MU': 'Mauritius', 'SC': 'Seychelles', 'MG': 'Madagascar', 'KM': 'Comoros',
    'RE': 'Réunion', 'YT': 'Mayotte', 'SH': 'Saint Helena', 'AC': 'Ascension Island',
    'TA': 'Tristan da Cunha', 'MX': 'Mexico', 'AR': 'Argentina', 'BR': 'Brazil',
    'CL': 'Chile', 'CO': 'Colombia', 'PE': 'Peru', 'VE': 'Venezuela',
    'EC': 'Ecuador', 'BO': 'Bolivia', 'PY': 'Paraguay', 'UY': 'Uruguay',
    'GY': 'Guyana', 'SR': 'Suriname', 'GF': 'French Guiana', 'PM': 'Saint Pierre and Miquelon',
    'GP': 'Guadeloupe', 'MQ': 'Martinique', 'CW': 'Curaçao', 'BQ': 'Bonaire',
    'AW': 'Aruba', 'CA': 'Canada', 'GT': 'Guatemala', 'SV': 'El Salvador',
    'HN': 'Honduras', 'NI': 'Nicaragua', 'CR': 'Costa Rica', 'PA': 'Panama',
    'BZ': 'Belize', 'JM': 'Jamaica', 'CU': 'Cuba', 'HT': 'Haiti',
    'DO': 'Dominican Republic', 'PR': 'Puerto Rico', 'IL': 'Israel', 'PS': 'Palestine',
    'AE': 'United Arab Emirates', 'QA': 'Qatar', 'BH': 'Bahrain', 'KW': 'Kuwait',
    'OM': 'Oman', 'YE': 'Yemen', 'SA': 'Saudi Arabia', 'IQ': 'Iraq',
    'JO': 'Jordan', 'LB': 'Lebanon', 'SY': 'Syria', 'IR': 'Iran',
    'AF': 'Afghanistan', 'PK': 'Pakistan', 'LK': 'Sri Lanka', 'MM': 'Myanmar',
    'BD': 'Bangladesh', 'NP': 'Nepal', 'BT': 'Bhutan', 'MV': 'Maldives'
  };
  
  return isoToCountryMap[isoCode] || isoCode;
};

// Helper function to generate flag emoji from ISO country code
export const getFlagFromISO = (isoCode) => {
  if (!isoCode || isoCode.length !== 2) return '🌍';
  
  // Convert ISO code to Unicode flag emoji
  const codePoints = isoCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt());
  
  return String.fromCodePoint(...codePoints);
};

// Get flag from country name (for countries stored by name in database)
export const getFlagFromCountryName = (countryName) => {
  const countryToISOMap = {
    'United States': 'US', 'United Kingdom': 'GB', 'France': 'FR', 'Germany': 'DE',
    'Italy': 'IT', 'Spain': 'ES', 'Netherlands': 'NL', 'Belgium': 'BE',
    'Switzerland': 'CH', 'Austria': 'AT', 'Denmark': 'DK', 'Sweden': 'SE',
    'Norway': 'NO', 'Finland': 'FI', 'Ireland': 'IE', 'Portugal': 'PT',
    'Greece': 'GR', 'Poland': 'PL', 'Czech Republic': 'CZ', 'Slovakia': 'SK',
    'Hungary': 'HU', 'Romania': 'RO', 'Bulgaria': 'BG', 'Croatia': 'HR',
    'Slovenia': 'SI', 'Estonia': 'EE', 'Latvia': 'LV', 'Lithuania': 'LT',
    'Russia': 'RU', 'Ukraine': 'UA', 'Belarus': 'BY', 'Moldova': 'MD',
    'Serbia': 'RS', 'Montenegro': 'ME', 'Kosovo': 'XK', 'Bosnia and Herzegovina': 'BA',
    'North Macedonia': 'MK', 'Albania': 'AL', 'Turkey': 'TR', 'Cyprus': 'CY',
    'Malta': 'MT', 'Iceland': 'IS', 'Faroe Islands': 'FO', 'Greenland': 'GL',
    'Andorra': 'AD', 'Monaco': 'MC', 'San Marino': 'SM', 'Vatican City': 'VA',
    'Liechtenstein': 'LI', 'China': 'CN', 'India': 'IN', 'Japan': 'JP',
    'South Korea': 'KR', 'Indonesia': 'ID', 'Malaysia': 'MY', 'Singapore': 'SG',
    'Thailand': 'TH', 'Vietnam': 'VN', 'Philippines': 'PH', 'Australia': 'AU',
    'New Zealand': 'NZ', 'Hong Kong': 'HK', 'Macau': 'MO', 'Taiwan': 'TW',
    'Egypt': 'EG', 'South Africa': 'ZA', 'Nigeria': 'NG', 'Kenya': 'KE',
    'Ghana': 'GH', 'Morocco': 'MA', 'Algeria': 'DZ', 'Tunisia': 'TN',
    'Libya': 'LY', 'Sudan': 'SD', 'Ethiopia': 'ET', 'Uganda': 'UG',
    'Tanzania': 'TZ', 'Rwanda': 'RW', 'Burundi': 'BI', 'Congo (DRC)': 'CD',
    'Congo': 'CG', 'Central African Republic': 'CF', 'Chad': 'TD',
    'Cameroon': 'CM', 'Equatorial Guinea': 'GQ', 'Gabon': 'GA',
    'São Tomé and Príncipe': 'ST', 'Cape Verde': 'CV', 'Senegal': 'SN',
    'Gambia': 'GM', 'Guinea': 'GN', 'Guinea-Bissau': 'GW', 'Sierra Leone': 'SL',
    'Liberia': 'LR', 'Côte d\'Ivoire': 'CI', 'Burkina Faso': 'BF',
    'Mali': 'ML', 'Niger': 'NE', 'Benin': 'BJ', 'Togo': 'TG',
    'Mauritius': 'MU', 'Seychelles': 'SC', 'Madagascar': 'MG', 'Comoros': 'KM',
    'Réunion': 'RE', 'Mayotte': 'YT', 'Saint Helena': 'SH',
    'Mexico': 'MX', 'Argentina': 'AR', 'Brazil': 'BR', 'Chile': 'CL',
    'Colombia': 'CO', 'Peru': 'PE', 'Venezuela': 'VE', 'Ecuador': 'EC',
    'Bolivia': 'BO', 'Paraguay': 'PY', 'Uruguay': 'UY', 'Guyana': 'GY',
    'Suriname': 'SR', 'French Guiana': 'GF', 'Guatemala': 'GT',
    'El Salvador': 'SV', 'Honduras': 'HN', 'Nicaragua': 'NI',
    'Costa Rica': 'CR', 'Panama': 'PA', 'Belize': 'BZ', 'Jamaica': 'JM',
    'Cuba': 'CU', 'Haiti': 'HT', 'Dominican Republic': 'DO',
    'Canada': 'CA', 'Israel': 'IL', 'Palestine': 'PS',
    'United Arab Emirates': 'AE', 'Qatar': 'QA', 'Bahrain': 'BH',
    'Kuwait': 'KW', 'Oman': 'OM', 'Yemen': 'YE', 'Saudi Arabia': 'SA',
    'Iraq': 'IQ', 'Jordan': 'JO', 'Lebanon': 'LB', 'Syria': 'SY',
    'Iran': 'IR', 'Afghanistan': 'AF', 'Pakistan': 'PK', 'Sri Lanka': 'LK',
    'Myanmar': 'MM', 'Bangladesh': 'BD', 'Nepal': 'NP', 'Bhutan': 'BT',
    'Maldives': 'MV'
  };
  
  const isoCode = countryToISOMap[countryName];
  return isoCode ? getFlagFromISO(isoCode) : '🌍';
};
